import React from 'react';

function StepActions({
  onBack,
  onPrimary,
  primaryLabel = 'Continuar',
  backLabel = 'Voltar',
  isSubmitting = false,
  showBack = true,
}) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mt-8">
      {showBack && onBack && (
        <button
          type="button"
          onClick={onBack}
          disabled={isSubmitting}
          className="btn-secondary flex-1 disabled:opacity-50"
        >
          {backLabel}
        </button>
      )}
      <button
        type="button"
        onClick={onPrimary}
        disabled={isSubmitting}
        className="btn-primary flex-1 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSubmitting ? 'Aguarde...' : primaryLabel}
      </button>
    </div>
  );
}

export default StepActions;
